import { axios } from '@/plugins/axios';

export function getInfosPSBEN2() {
	return axios.get('/aat-api/psben2/infos');
}

export function extendSession() {
	return axios.get('/aat-api/session/extend');
}
